import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import axios from "../../../library/axios";
import { formatDate } from "../../../helpers/formatDate";
import { getSlug, } from "../../../../src/config/routes/guards/slug";

Chart.register(...registerables);

const ChartOneInternal = () => {
  const [listAkreditasi, setlistAkreditasi] = useState([]);
  const [persentasePokja, setpersentasePokja] = useState([]);
  const [persentaseMutu, setpersentaseMutu] = useState([]);
  const [singkatan, setsingkatan] = useState([]);
  const [singkatanIdeal, setsingkatanIdeal] = useState([]);
  const [idKegiatanAkreditasi, setidKegiatanAkreditasi] = useState("");

  const [scoreIdeal, setscoreIdeal] = useState([]);
  const [scoreActual, setscoreActual] = useState([]);

  const handleChangePerideSurvei = async (id) => {
    setidKegiatanAkreditasi(id);
    fetchDataScore(id);
    try {
      const options = {
        url: `/skor/skoring-bar-chart/${id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      // return false

      setsingkatan([]);
      data.capaian.map((d) =>
        setsingkatan((singkatan) => [...singkatan, d.singkatan])
      );

      setpersentasePokja([]);
      data.capaian.map((d) =>
        setpersentasePokja((persentasePokja) => [
          ...persentasePokja,
          d.percentage,
        ])
      );

      setpersentaseMutu([]);
      data.mutu.map((d) =>
        setpersentaseMutu((persentaseMutu) => [...persentaseMutu, d.percentage])
      );
    } catch (err) {
      console.log(err);
    }
  };

  const fetchDataScore = async (id) => {
    try {
      const options = {
        url: `/skor/skoring-bar-chart-skor/${id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      // return false

      setsingkatanIdeal([]);
      data.ideal_skor.map((d) =>
        setsingkatanIdeal((singkatanIdeal) => [...singkatanIdeal, d.Singkatan])
      );

      setscoreIdeal([]);
      data.ideal_skor.map((d) =>
        setscoreIdeal((scoreIdeal) => [...scoreIdeal, d.skorIdeal])
      );

      setscoreActual([]);
      data.skor_mutu.map((d) =>
        setscoreActual((scoreActual) => [...scoreActual, d.skorSurveyor])
      );
    } catch (err) {
      console.log(err);
    }
  };

  const fetchSurvei = async () => {
    try {
      const options = {
        url: `/accreditations/list`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setlistAkreditasi(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchSurvei();
  }, []);

  const data = {
    labels: singkatan,
    datasets: [
      {
        label: "Capaian Pengisian Pokja",
        data: persentasePokja,
        backgroundColor: [
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
        ],
        borderColor: [
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
        ],
        borderWidth: 1,
      },
      {
        label: "Capaian Pengisian Mutu",
        data: persentaseMutu,
        backgroundColor: [
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
          "rgba(15, 232, 23, 1)",
        ],
        borderColor: [
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const dataNilai = {
    labels: singkatanIdeal,
    datasets: [
      {
        label: "Nilai Ideal",
        data: scoreIdeal,
        backgroundColor: [
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
          "rgba(23, 190, 207, 0.8)",
        ],
        borderColor: [
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
        ],
        borderWidth: 1,
      },
      {
        label: "Nilai Aktual",
        data: scoreActual,
        backgroundColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
          "rgba(255, 99, 132, 1)",
        ],
        borderColor: [
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  // console.log(scoreActual)

  return (
    <>
      <div className="col-lg-4 col-12 mb-5">
        <label className="form-label">Periode Survei</label>
        <select
          className="form-select"
          value={idKegiatanAkreditasi}
          onChange={(e) => handleChangePerideSurvei(e.target.value)}
        >
          <option>- Pilih -</option>
          {listAkreditasi.map((accreditation) => (
            <option key={accreditation.id} value={accreditation.id}>
              {formatDate(accreditation.TglMulai)} S/D{" "}
              {formatDate(accreditation.TglBerakhir)}
            </option>
          ))}
        </select>
      </div>
      {
        idKegiatanAkreditasi ?
          <>
            <div className="row" style={{ marginBottom: '35px' }}>
              <div className="col-12">
                <h2 style={{ marginTop: '15px' }}>Grafik 1 : Capaian Pengisian Self Assessment</h2>
                <h6 style={{ marginTop: '15px' }} className="text-info mb-3">Grafik ini menunjukan progress pengisian Self Assessment per masing-masing Bab. <br /> Jika angka sudah mencapai 100% berarti semua EP di Bab tersebut sudah berhasil ternilai.</h6>
                <hr></hr>
                <Bar data={data} options={options} />
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-12">
                <h2 style={{ marginTop: '15px' }}>Grafik 2 : Akumulasi Skor Self Assessment VS Skor ideal Lembaga</h2>
                <h6 style={{ marginTop: '15px' }} className="text-info mb-3">Grafik ini menunjukan akumulasi skor dari pengisian Self Assessment per masing-masing Bab. <br /> Akumulasi skor sebaiknya melebihi batas Nilai Ideal Lembaga.</h6>
                <hr></hr>
                <Bar data={dataNilai} options={options} />
              </div>
            </div>
          </>
          :
          ""
      }

    </>
  );
};

export default ChartOneInternal;
